import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faBell } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { List, Result } from "antd";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import timezone from "dayjs/plugin/timezone";

import React from "react";
import { CommandMessage } from "../../dashboard/CommandTypes";
import Helper from "../../Helper";

dayjs.extend(localizedFormat);
dayjs.extend(timezone);

interface NotificationsFeedProps {
    messages: CommandMessage[];
    timezone: string;
}

const NotificationsFeed: React.FC<NotificationsFeedProps> = ({ messages, timezone }) => {
    const renderItem = (item: CommandMessage, index: number) => {
        return (
            <List.Item key={index} className="p-0!">
                <div className="p-3 border-b border-neutral-700 w-full">
                    <p className="text-sm text-neutral-200 font-medium">{item.body}</p>
                    <div className="flex flex-row items-center justify-between gap-2 w-full">
                        <div className="mt-1 flex flex-row items-center gap-2">
                            {item.sender?.avatar_url ? (
                                <img
                                    src={item.sender.avatar_url}
                                    alt="Sender Avatar"
                                    className="w-6 h-6 rounded-full object-cover"
                                />
                            ) : (
                                <div className="w-6 h-6 rounded-full bg-neutral-600" />
                            )}
                            <div className="text-xs text-neutral-400 ">{item.sender?.fullname || ""}</div>
                        </div>
                        <div className="text-xs text-neutral-500 mt-1">
                            {Helper.notificationsDateStringFormatter(dayjs(item.created_at).tz(timezone))}
                            {dayjs(item.created_at).tz(timezone).format("LTS")}
                        </div>
                    </div>
                </div>
            </List.Item>
        );
    };

    return (
        <div className="flex-1 bg-neutral-800 border border-neutral-700 rounded-lg overflow-hidden flex flex-col w-full h-full min-h-0">
            <div className="flex-1 overflow-y-auto">
                {messages && messages.length > 0 ? (
                    <List dataSource={messages} renderItem={(item, index) => item && renderItem(item, index)} />
                ) : (
                    <div className="h-full flex bg-plot-slate items-center justify-center">
                        <Result
                            className="text-white"
                            icon={<FontAwesomeIcon icon={faBell as IconProp} color="#ff9e00" size="2x" />}
                            title={
                                <div className="text-sm uppercase text-gray-900 dark:text-neutral-100 font-semibold mb-2 leading-tight text-center break-words px-1">
                                    No Jobsite Alerts Have Been Sent yet
                                </div>
                            }
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default NotificationsFeed;
